import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

export const resetOrgGroup = () => ({
  type: types.RESET_ORG_GROUP,
})

export const setOrgGroupSearchValue = (value) => ({
  type: types.SET_ORG_GROUP_SEARCH_VALUE,
  value,
})

export const filterGroupLocations = (value) => ({
  type: types.SET_GROUP_LOCATIONS_FILTER_VALUE,
  value,
})
export const onNameChange = (value) => ({
  type: types.SET_ORG_GROUP_NAME,
  value,
})

export const fetchOrgGroups = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_LOADING, value: true })
    AxiosInstance.get(`/org-groups`).then((orgGroups) => {
      dispatch({ type: types.SET_LOADING, value: false })
      dispatch({ type: types.SET_ORG_GROUPS, orgGroups: orgGroups.message })
    })
  }
}

export const fetchOrgGroup = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/org-groups/${id}/details`).then((orgGroup) => {
      dispatch({
        type: types.SET_ORG_GROUP,
        value: (orgGroup.message && orgGroup.message.group) || {},
      })
      dispatch({
        type: types.SET_ORG_GROUP_GROUPS,
        value: (orgGroup.message && orgGroup.message.children) || [],
      })
    })
  }
}

export const deleteOrgGroup = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : (language = null)
    // if (confirm(language.alerts ? language.alerts.delete_org_group_confirm : null)) {
    AxiosInstance.delete(`/org-groups/${id}`).then((data) => {
      if (data.statusCode === 200) {
        const actualOrgGroups = getState().orgGroups.orgGroups.filter(
          (item) => item.id !== id
        )
        dispatch({ type: types.SET_ORG_GROUPS, orgGroups: actualOrgGroups })
      } else {
      }
    })
    // }
  }
}

export const toggleLocationGroup = (id) => {
  return (dispatch, getState) => {
    const selectedLocationGroups = getState().orgGroups.orgGroupChildren
    const index = selectedLocationGroups.findIndex((item) => item === id)

    if (index === -1) {
      dispatch({
        type: types.SET_ORG_GROUP_GROUPS,
        value: [...selectedLocationGroups, id],
      })

      return
    }

    const newLocationGroups = [
      ...selectedLocationGroups.slice(0, index),
      ...selectedLocationGroups.slice(index + 1),
    ]

    dispatch({ type: types.SET_ORG_GROUP_GROUPS, value: newLocationGroups })
  }
}

export const updateOrgGroup = (data) => {
  return (dispatch, getState) => {
    const state = getState()
    const orgGroup = state.orgGroups && state.orgGroups.orgGroup
    const orgGroupChildren = state.orgGroups && state.orgGroups.orgGroupChildren

    if (orgGroup.id) {
      AxiosInstance.put(`/org-groups/${orgGroup.id}`, {
        name: orgGroup.name || '',
        children: orgGroupChildren.join(','),
      })
        .then(() => dispatch(fetchOrgGroups()))
        .catch(() => dispatch(fetchOrgGroups()))
    } else {
      AxiosInstance.post(`/org-groups/`, {
        name: orgGroup.name || '',
        groups: orgGroupChildren.join(','),
      })
        .then(() => dispatch(fetchOrgGroups()))
        .catch(() => dispatch(fetchOrgGroups()))
    }
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const value = getState().orgGroups.searchValue
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
  }
}

export const onResetSearch = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_ORG_GROUP_SEARCH_VALUE, value: '' })
  }
}
